module.exports = "/_next/static/images/Ivan_Galkin-f0ff50710dd99c3b95787612eb06289e.webp";